export default __webpack_public_path__ + "static/media/avatar10-mujer.882dc4ef.png";